var _g, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetwork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 492 492",
    style: {
      enableBackground: "new 0 0 492 492"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.3,16.9c-3.3-4.8-2-11.4,2.8-14.6c4.8-3.3,11.4-2,14.6,2.8l86.1,127.1c4.7,7-0.3,16.5-8.7,16.5H86.6l67.4,99.5l9.3-26.7 c1.9-5.5,7.9-8.4,13.4-6.5c5.5,1.9,8.4,7.9,6.5,13.4L167,274.9c-2.9,8.2-13.8,9.6-18.7,2.4L58,144c-4.7-7,0.3-16.5,8.7-16.5h70.5 L62.3,16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.1,253.2c-5.8-0.9-11.1,3.1-12,8.9c-0.9,5.8,3.1,11.1,8.9,12l52.9,8c9.1,1.4,15.4-8.7,10.3-16.3L76.7,131.9 c-3.2-4.8-9.8-6.1-14.6-2.9c-4.8,3.2-6.1,9.8-2.9,14.6l76.2,114L106.1,253.2z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M307.6,102.8l79.6,380.4c1.2,5.7,6.8,9.4,12.5,8.2c5.7-1.2,9.4-6.8,8.2-12.5L317.5,47.1c-2.4-11.3-18.5-11.1-20.7,0.2 L214,479.1c-1.1,5.7,2.6,11.2,8.4,12.3c5.7,1.1,11.2-2.6,12.3-8.4L307.6,102.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.3,372.3h234c5.8,0,10.5-4.7,10.5-10.5c0-5.8-4.7-10.5-10.5-10.5h-234c-5.8,0-10.5,4.7-10.5,10.5 C180.8,367.6,185.5,372.3,191.3,372.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M246.9,228.5h120.5c7,0,12.6-5.7,12.6-12.6c0-7-5.7-12.6-12.6-12.6H246.9c-7,0-12.6,5.7-12.6,12.6 C234.3,222.9,240,228.5,246.9,228.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M216.8,302.2h180.7c5.8,0,10.5-4.7,10.5-10.5c0-5.8-4.7-10.5-10.5-10.5H216.8c-5.8,0-10.5,4.7-10.5,10.5 C206.3,297.5,211,302.2,216.8,302.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/Network.f43d4eda.svg";
export { ForwardRef as ReactComponent };